// extracted by mini-css-extract-plugin
export default {"productGrid":"d0-z","centerLink":"e0-z","productSection":"f0-z","item":"g0-z","ctaButton":"h0-z"};